import { Component, input } from '@angular/core';

@Component({
  selector: 'app-header-banner',
  imports: [],
  template: ` <div class="card border-0 header-banner mb-3">
    <div
      class="card-body"
      [style.background-image]="'url(' + imageUrl() + ')'">
      <div class="h1">{{ title() }}</div>
    </div>
  </div>`,
  styleUrl: '../../../../static/styles/components/header-banner.scss',
})
export class HeaderBannerComponent {
  title = input.required<string>();
  imageUrl = input.required<string>();
}
